import { render, staticRenderFns } from "./QuanyuChart.vue?vue&type=template&id=f078bf90&scoped=true"
import script from "./QuanyuChart.vue?vue&type=script&lang=js"
export * from "./QuanyuChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f078bf90",
  null
  
)

export default component.exports